<div class="back-wrapper">
    <div class="oops-container">
        <h1>Oops.... there was an error</h1>
        <p>The page you tried to access doesn't exist or you don't have access</p>
        <a class="home-link" href="" [routerLink]="['/']" routerLinkActive="router-link-active">Click here to go Home</a>
    </div>
</div>